module.exports = "/_next/static/images/Logoeng-f23c96209c35f2d1396aeb3de4832b52.png";